import Immutable from "immutable";
import { LOCATION_CHANGE } from "react-router-redux";

export const globalMap = Immutable.Map({
  breadCrumbTrail: Immutable.List()
});

export const globalReducer = (state = globalMap, action) => {
  let nextState = state;

  switch (action.type) {
    /**
     * Tap into the React Router LOCATION_CHANGE action to create a breadcrumb trail
     */
    case LOCATION_CHANGE: {
      const routerState = action.payload.location.state;

      if (routerState && routerState.addToBreadCrumbTrail === "add") {
        nextState = nextState.updateIn(["breadCrumbTrail"], arr => arr.push(
          Immutable.Map({
            url: action.url,
            buttonText: routerState.buttonText
          })
        ));
      } else if (routerState && routerState.addToBreadCrumbTrail === "remove") {
        nextState = nextState.updateIn(["breadCrumbTrail"], arr => arr.pop());
      } else {
        nextState = nextState.updateIn(["breadCrumbTrail"], arr => arr.clear());
      }

      return nextState;
    }

    default:
      return nextState;
  }
};
